import { AfterViewChecked, Component, Input } from '@angular/core';
import { HighlightService } from 'src/app/service/highlight.service';

@Component({
  selector: 'app-prism-xml',
  templateUrl: './prism-xml.component.html',
  styleUrls: ['./prism-xml.component.scss']
})
export class PrismXmlComponent implements AfterViewChecked {
  @Input() xmlData: any;

  constructor(private highlightService: HighlightService) {}

  ngAfterViewChecked() {
    this.highlightService.highlightAll();
  }
}
